import { useEffect } from 'react';
import { isSyntheticMonitor } from '../utils';

declare global {
  interface Window {
    zE?: (...args: unknown[]) => void;
  }
}

function useLoadZenDesk(): void {
  useEffect(() => {
    if (globalThis.window === undefined) {
      return;
    }

    if (isSyntheticMonitor()) {
      return;
    }

    if (document.getElementById('ze-snippet') !== null) {
      return;
    }

    const script = document.createElement('script');
    script.src =
      'https://static.zdassets.com/ekr/snippet.js?key=c2d2a5b6-2a4e-418d-be7e-076294511aed';
    script.id = 'ze-snippet';
    script.async = true;
    script.onload = () => {
      if (globalThis.window.zE) {
        globalThis.window.zE('messenger:set', 'conversationTags', [
          'tax_advisor_page'
        ]);
      }
    };
    document.body.appendChild(script);

    const style = document.createElement('style');
    style.textContent = `
      iframe#launcher,
      iframe#webWidget,
      div[data-product="web_widget"],
      iframe[data-product="web_widget"],
      iframe[title="Messaging window"],
      iframe[title="Number of unread messages"],
      iframe[title="Button to launch messaging window"] {
        left: auto !important;
        right: 16px !important;
      }
    `;
    document.head.appendChild(style);
  }, []);
}

export { useLoadZenDesk };
